import type { FaireProductEntity } from "../../entity_types/product";

export const p_77vv43hn63: FaireProductEntity = {
  token: "p_77vv43hn63",
  type: "product",
  name: "18K Gold Filled Infinity Loop necklace",
  brandToken: "b_n2jsjnhwd3",
  brandName: "Furano Studio",
  imageUrl:
    "https://cdn.faire.com/fastly/34f6d19b93f578fda7bd96896a9808f6821dd76ac78e784bf0477109fff20681.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/88c3b90165b8d4140528f8e4566d6c6f59fd82d944900c8e5e5eab89a702b079.jpeg",
    "https://cdn.faire.com/fastly/f687c642a0d1c853e44ff1c03931b85fd49f25dedfe5213e80231623e3a5434f.jpeg",
    "https://cdn.faire.com/fastly/35492fad384fbee529787a3ced2f1c3d6c4ef7f7e88aad8ba1297441ddd9392a.jpeg",
    "https://cdn.faire.com/fastly/c2951f702b6f274635d908af72e03b10414f48f070b6d1571a61a49a7b518fa0.jpeg",
    "https://cdn.faire.com/fastly/1f1cae873125d872afb1a96f1d1f2f0b3e3cd7b6ea3e01b24abe18f0e4a837ee.jpeg",
    "https://cdn.faire.com/fastly/2044010333983c1dc9816670d3034925ec074e5fa4e0bf8273c687a8367dea97.jpeg",
  ],
  priceDollars: 10.99,
  description:
    "• Length: 16 inches + 2 inches adjustable\n• Material: 18K Gold Filled on Titanium Steel",
  tags: [],
  msrpDollars: 46.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:38.557Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
